import { capitalize } from './string';

const ERROR_CODE = /^[A-Z][A-Z0-9_]*$/;

const GENERIC_ACRONYMS = ['ID', 'URL'];

interface FormatIssueMessageOptions {
  /** Acronyms as they should read, e.g. `UBOs`, kept as written while the code's other words are lowercased */
  acronyms?: readonly string[];
}

/** A code such as `COMPANY_NAME_REQUIRED` reads as a sentence; any other message is already prose */
export const formatIssueMessage = (message: string, { acronyms = [] }: FormatIssueMessageOptions = {}) => {
  if (!ERROR_CODE.test(message)) return message;

  const written = new Map([...GENERIC_ACRONYMS, ...acronyms].map((acronym) => [acronym.toUpperCase(), acronym]));
  const words = message
    .split('_')
    .filter(Boolean)
    .map((word) => written.get(word) ?? word.toLowerCase());

  return capitalize(words.join(' '));
};

/** A zod issue path as it reads in JSON, e.g. `programs.BTC_USD_P[0].compensation`. */
export const formatIssuePath = (path: readonly PropertyKey[]) =>
  path
    .map((part) => (typeof part === 'number' ? `[${part}]` : `.${String(part)}`))
    .join('')
    .replace(/^\./, '');
